import request from '@/utils/request'
import { ConstConfig } from '@/utils'

export function getMatchInfo(matchId) {
  const params = {
    matchId: matchId
  }
  return request({
    url: ConstConfig.apiPath + '/GetBMMatchInfo.json',
    method: 'get',
    params
  })
}

export function getBMMatchSignUpRule(matchId) {
  const params = {
    matchId: matchId
  }
  return request({
    url: ConstConfig.apiPath + '/GetBMMatchSignUpRule.json',
    method: 'get',
    params
  })
}

export function getMyTeamsForMatch(matchId) {
  const params = {
    matchId: matchId
  }
  return request({
    url: ConstConfig.apiPath + '/GetMyTeamsForMatch.json',
    method: 'get',
    params
  })
}

export function signupBMMatchTeams(data) {
  return request({
    url: ConstConfig.apiPath + '/SignupBMMatchTeams.json',
    method: 'post',
    data
  })
}

export function getAreaList(areaId) {
  const params = {
    parentId: areaId,
    disableSpecialLogic: 1
  }
  return request({
    url: ConstConfig.apiPath + '/GetAreaList.json',
    method: 'get',
    params
  })
}

export function getBMMarketSubjectList(params) {
  return request({
    url: ConstConfig.apiPath + '/GetBMMarketSubjectList.json',
    method: 'get',
    params
  })
}

export function createMatchServiceReservationOrder(params) {
  params.appVersion = ConstConfig.appVersion
  return request({
    url: ConstConfig.apiPath + '/CreateMatchServiceReservationOrder.json',
    method: 'get',
    params
  })
}

export function getMatchServiceReservationOrderPageInfo(params) {
  params.appVersion = ConstConfig.appVersion
  return request({
    url: ConstConfig.apiPath + '/GetMatchServiceReservationOrderPageInfo.json',
    method: 'get',
    params
  })
}

export function addBMVideoServiceOrder(params) {
  params.appVersion = ConstConfig.appVersion
  return request({
    url: ConstConfig.apiPath + '/AddBMVideoServiceOrder.json',
    method: 'get',
    params
  })
}

export function bkGetGameDetail(params) {
  params.appVersion = ConstConfig.appVersion
  return request({
    url: ConstConfig.apiPath + '/BKGetGameDetail.json',
    method: 'get',
    params
  })
}

/*
export function bkGetGameLiveInfo(params) {
  params.appVersion = ConstConfig.appVersion
  return request({
    url: ConstConfig.apiPath + '/BKGetGameLiveInfo.json',
    method: 'get',
    params
  })
} */

export function bkGetGameLiveInfo(params) {
  params.appVersion = ConstConfig.appVersion
  return request({
    url: ConstConfig.apiPath + '/GetBMGameBktPlaybackInfo2.json',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/match.js